import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecitemcategory/cecItemCategory/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecitemcategory/cecItemCategory/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecitemcategory/cecItemCategory/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecitemcategory/cecItemCategory/list',
      method: 'get',
      params: params
    })
  },
  allList: function (params) {
    return request({
      url: '/cecitemcategory/cecItemCategory/allList',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecitemcategory/cecItemCategory/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecitemcategory/cecItemCategory/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecitemcategory/cecItemCategory/import',
      method: 'post',
      data: data
    })
  }
}
